import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End

import { WorkbenchComponent } from './workbench/workbench.component';
import { ClaimDashboardComponent } from './claim-dashboard/claim-dashboard.component'
import { ClaimsAuthenticationGuard } from '../claims-guards'
import { WorkflowConfigurator } from 'app/ViewModules/shared-components/workflow-configurator/workflow-configurator.component';
import { SearchConfigurationComponent } from 'app/ViewModules/shared-components/search-configuration/search-configuration.component';


var routeList = [
    {
        path: 'workbench',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Workbench',
            inboxType: 'workbench'
        },
    },
    {
        path: 'enquiry',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Enquiry',
            inboxType: 'enquiry'
        },
    },
    {
        path: 'partner-inbox',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Workbench',
            inboxType: 'partner-inbox'
        },
    },
    {
        path: 'claims-dashboard',
        component: ClaimDashboardComponent,
        data: {
            breadcrumb: 'Claims Dashboard'
        }
    },
    {
        path: 'search-config',
        component: SearchConfigurationComponent,
        data: {
            breadcrumb: 'Workflow Configurator'
        }
    },
    {
        path: 'workflow-configurator',
        component: WorkflowConfigurator,
        data: {
            breadcrumb: 'Workflow Configurator'
        }
    },
    

];

/* DASHBOARD: CLAIMS */



const routes: Routes = [
    ...routeList
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class InboxRoutingModule { } 
